export default __webpack_public_path__ + "assets/MyriadPro-BoldCondIt.8ab1da98.svg";